const singularOrPluralText = (
  count: number,
  singularText: string,
  pluralText: string
) => (count !== 1 ? pluralText : singularText);

export default singularOrPluralText;
